import styled from 'styled-components';
export const ItemsContainer = styled.div`
  overflow: auto;
`;
